import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si recién me recibí?',
    a: 'Especialmente para vos. Arrancás con estructura de consultorio establecido desde el primer día.'
  }, {
    q: '¿Sirve si ya tengo experiencia?',
    a: 'Sí. Lo que más valoran las nutricionistas experimentadas: Tomo 4 (patologías), Tomo 5 (deporte) y los bonos de primera consulta y menús rotativos.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Email con link de descarga inmediata después del pago. Todo en PDF. En tu dispositivo para siempre.'
  }, {
    q: '¿Es material argentino o genérico?',
    a: '100% argentino. Normativa local vigente, alimentos de góndola argentina, scripts con voseo, referencias a GAPA, MSAL y ANMAT.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, devolución total, sin preguntas. Escribís a soporte.tumanualdigital@gmail.com y listo.'
  }];
  return <section className="py-14 px-4 max-w-3xl mx-auto" data-id="element-111">
      <FadeIn data-id="element-112">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-113">
          <span className="text-4xl" data-id="element-114">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-115">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-116" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-800 rounded-xl bg-gray-900/50 overflow-hidden" data-id="element-117">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-118">
        <span className="font-bold text-lg text-gray-200" data-id="element-119">{question}</span>
        <ChevronDown className={`text-green-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-120" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-121">
        <p className="text-gray-400 leading-relaxed" data-id="element-122">{answer}</p>
      </div>
    </div>;
}